import { FollowItem } from '@deckee/api-app-main';

export const transformApiToLocalModel = (
  followItem: FollowItem,
): FollowModel => ({
  ...followItem,
  followee: {
    ...followItem.followee,
    displayName: followItem.followee.username || followItem.followee.title,
  },
  follower: {
    ...followItem.follower,
    displayName: followItem.follower.username || followItem.follower.title,
  },
});

export interface FollowModel extends FollowItem {
  followee: FollowItem['followee'] & {
    displayName: string;
  };
  follower: FollowItem['follower'] & {
    displayName: string;
  };
}

export default {};
